var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50033 2.47949C5.18037 2.47949 2.47949 5.18037 2.47949 8.50033C2.47949 11.8203 5.18037 14.5212 8.50033 14.5212C11.8203 14.5212 14.5212 11.8203 14.5212 8.50033C14.5212 5.18037 11.8203 2.47949 8.50033 2.47949ZM8.50033 15.5837C4.59458 15.5837 1.41699 12.4061 1.41699 8.50033C1.41699 4.59458 4.59458 1.41699 8.50033 1.41699C12.4061 1.41699 15.5837 4.59458 15.5837 8.50033C15.5837 12.4061 12.4061 15.5837 8.50033 15.5837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9312 11.1159C10.8384 11.1159 10.7449 11.0918 10.6592 11.0415L7.98874 9.44849C7.82866 9.35216 7.72949 9.17862 7.72949 8.99162V5.55762C7.72949 5.26437 7.96749 5.02637 8.26074 5.02637C8.5547 5.02637 8.79199 5.26437 8.79199 5.55762V8.68987L11.2039 10.1278C11.4553 10.2787 11.5382 10.6045 11.388 10.8567C11.2882 11.0231 11.1118 11.1159 10.9312 11.1159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.973f6063422e59aea38ed487a4638263.svg";
export { ForwardRef as ReactComponent };